define('lq/responsive',[
    'jquery',
    'underscore',
    'lq/constants',
    'lq/drop',
    'lq/util'
], function ($, _, constants, Drop, util) {
    'use strict';

    var orientations = constants.orientations;
    var deviceTypes = constants.deviceTypes;
    var layoutTypes = constants.layoutTypes;

    // for now these are hardcoded and apply to all drops
    var propertiesThatAreAlwaysLayoutDependend = [
        'position',
        'size',
        'top',
        'right',
        'bottom',
        'left',
        'centered',
        'toPage',
        'styles',
        'initialVisibilityOption',
        'initialVisibility',
        'dataSourceForVisibility',
        'dataSourceOutputForVisibility',
        'parameterForVisibility',
        'parameterForVisibility'
    ];

    var propertiesThatShouldBeDeletedIfTheyDoNotExist = [
        'top',
        'right',
        'bottom',
        'left',
        'centered'
    ];

    // these should be moved to their respective drop
    var propertiesThatAreLayoutDependendByType = {
        'List': [
            'childPositionX',
            'childPositionY',
            'childSizeX',
            'childSizeY'
        ],
        'Gauge': [
            'indicatorScale'
        ],
        'Image': [
            'cropPositionX',
            'cropPositionY',
            'cropImageWidth',
            'cropImageHeight',
            'selectedResizeOption',
            'backgroundRepeat'
        ],
        'Text': [
            'applyBestFontFit'
        ]
    };

    var getDeviceType = function () {
        // based on http://detectmobilebrowsers.com/
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent)
             ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4)))
            return deviceTypes.Phone;
        else if (/android|ipad|playbook|silk/i.test(userAgent))
            return deviceTypes.Tablet;
        else
            return deviceTypes.Desktop;
    };

    var getOrientation = function () {
        //css orientation detection is buggy, returns landscape when you open the keyboard in portrait mode (seems to use width/height > 1)
        //return window.matchMedia && window.matchMedia("(orientation: portrait)").matches ? orientations.Portrait : orientations.Landscape;
        
        if (window.screen && window.screen.orientation) {
            var isLandscape = window.screen.orientation.type.indexOf('landscape') !== -1;
            return isLandscape ? orientations.Landscape : orientations.Portrait;
        }

        // for some reason 'outerWidth' and 'outerHeight' will return '0' on (some) versions of Safari
        var $window = $(window);
        var width = window.outerWidth || $window.width();
        var height = window.outerHeight || $window.height();
        return width / height > 1.3 ? orientations.Landscape : orientations.Portrait;
    };

    var getLayoutType = function (deviceType, orientation) {
        if (deviceType === deviceTypes.Desktop)
            return layoutTypes.Desktop;
        else
            return layoutTypes[deviceType.name + orientation.name];
    };

    // TODO: get alternate layout (same device, different orientation)
    var getBrowserLayout = function () {
        var deviceType = this.getDeviceType();
        var orientation = this.getOrientation();
        var layoutType = this.getLayoutType(deviceType, orientation);
        return {
            layoutType: layoutType,
            deviceType: deviceType,
            orientation: orientation
        };
    };

    var getLayoutTypeFromUri = function () {
        var queryString = window.location.hash || '#';
        var queryParameters = util.parseUriQuery(queryString.substr(1));
        return parseInt(queryParameters.layoutType, 10);
    };

    var getLayoutIdFromUri = function () {
        var queryString = window.location.hash || '#';
        var queryParameters = util.parseUriQuery(queryString.substr(1));
        return queryParameters.layoutId;
    };

    var getBrowserLayoutType = function () {
        var browserLayout = this.getBrowserLayout();
        return browserLayout.layoutType.getIndex();
    };

    var getCurrentLayoutType = function (rootDrop) {
        var layoutTypeOverride = this.getLayoutTypeFromUri();

        if (layoutTypeOverride >= 0)
            return layoutTypeOverride;

        // allow root drop to override browser type detection layout choice
        if (typeof rootDrop.getInitialLayoutType == 'function')
            layoutTypeOverride = rootDrop.getInitialLayoutType();

        if (layoutTypeOverride >= 0)
            return layoutTypeOverride;

        return this.getBrowserLayoutType();
    };

    var getBrowserResolution = function () {
        var w = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0];
        return {
            x: w.innerWidth || e.clientWidth || g.clientWidth,
            y: w.innerHeight || e.clientHeight || g.clientHeight
        };
    };

    var getDefaultLayoutType = function (rootDrop) {
        var defaultLayout = rootDrop.defaultLayout || { layoutType: 0 };
        return defaultLayout.layoutType;
    };

    var isDefaultLayout = function () {
        var currentLayout = this.getCurrentLayout();
        return !currentLayout || currentLayout.isDefault;
    };

    var getCurrentLayout = function (rootDrop) {
        var currentLayoutId = this.getLayoutIdFromUri();
        var selectedLayout = currentLayoutId && _.findWhere(rootDrop.allLayouts, { id: currentLayoutId });
        if (selectedLayout)
            return selectedLayout;

        var currentLayoutType = this.getCurrentLayoutType(rootDrop);
        var layoutsMatchingDeviceSortedBySize = _.chain(rootDrop.allLayouts)
            .where({ layoutType: currentLayoutType })
            .sortBy('resolutionX')
            .value();
        var browserSize = this.getBrowserResolution();
        var fittingLayoutsSortedBySize = _.filter(layoutsMatchingDeviceSortedBySize, function (layoutInfo) {
            return layoutInfo.resolutionX <= browserSize.x && layoutInfo.resolutionY <= browserSize.y;
        });

        if (fittingLayoutsSortedBySize.length > 0)
            return _.last(fittingLayoutsSortedBySize);

        if (layoutsMatchingDeviceSortedBySize.length > 0) {
            if (layoutsMatchingDeviceSortedBySize.length === 1)
                return layoutsMatchingDeviceSortedBySize[0];

            // take the smallest resolution when that resolution is larger than the screen 
            var first = _.first(layoutsMatchingDeviceSortedBySize);
            if (first.resolutionX > browserSize.x || first.resolutionY > browserSize.y)
                return first;

            // default to the largest resolution
            return _.last(layoutsMatchingDeviceSortedBySize);
        }

        // probably not 100% correct. a better solution: find the one that matches best.
        if (rootDrop.data.appliedLayouts && rootDrop.data.appliedLayouts.length > 0 && _.indexOf(rootDrop.data.appliedLayouts, rootDrop.defaultLayout.id) === -1) {
            return _.findWhere(rootDrop.allLayouts, { id: rootDrop.data.appliedLayouts[0] });
        }
        
        return rootDrop.defaultLayout;
    };

    var copyDropLayout = function (dropType, sourceData, targetData) {
        if (propertiesThatAreLayoutDependendByType[dropType]) {
            _.each(propertiesThatAreLayoutDependendByType[dropType], function (prop) {
                if (!_.isUndefined(sourceData[prop]))
                    targetData[prop] = sourceData[prop];
            });
        }

        _.each(propertiesThatAreAlwaysLayoutDependend, function (prop) {
            if (!_.isUndefined(sourceData[prop])) {
                targetData[prop] = sourceData[prop];
            } else if (_.indexOf(propertiesThatShouldBeDeletedIfTheyDoNotExist, prop) !== -1) {
                // WHY if a property does not exist, we will always fallback to the value of the
                // default layout. Unfortunately the anchoring code assumes the anchor properties
                // do not exist when anchoring is not enabled, i.e. when you disable anchoring in a
                // non-default layout the designer will always fallback to the anchoring of the
                // default layout
                delete targetData[prop];
            }
        });
    };

    var applyLayoutRecursiveToChildren = function (drop, layoutInfo) {
        _.each(drop.childDrops, function (childDrop) {
            var currentDropLayout = _.findWhere(childDrop.data.layouts, { layoutId: layoutInfo.id });
            if (currentDropLayout) copyDropLayout(childDrop.data.type, currentDropLayout, childDrop.data);
            applyLayoutRecursiveToChildren(childDrop, layoutInfo);
        });

        _.each(drop.backgroundDrops, function (childDrop) {
            var currentDropLayout = _.findWhere(childDrop.data.layouts, { layoutId: layoutInfo.id });
            if (currentDropLayout) copyDropLayout(childDrop.data.type, currentDropLayout, childDrop.data);
            applyLayoutRecursiveToChildren(childDrop, layoutInfo);
        });
    };

    var applyLayoutRecursive = function (rootDrop, layoutInfo) {
        var currentDropLayout = _.findWhere(rootDrop.data.layouts, { layoutId: layoutInfo.id });

        if (currentDropLayout) {
            this.copyDropLayout(rootDrop.type, currentDropLayout, rootDrop.data);
        } else if (!layoutInfo.isDefault) {
            this.copyDropLayout(rootDrop.type, {
                size: {
                    x: layoutInfo.resolutionX,
                    y: layoutInfo.resolutionY
                },
                position: {
                    x: 0,
                    y: 0
                },
                top: null,
                left: null,
                bottom: null,
                right: null,
                centered: false
            }, rootDrop.data);
        }

        applyLayoutRecursiveToChildren(rootDrop, layoutInfo);
    };

    return {
        orientations: constants.orientations,
        deviceTypes: constants.deviceTypes,
        layoutTypes: constants.layoutTypes,
        getDeviceType: getDeviceType,
        getOrientation: getOrientation,
        getBrowserLayout: getBrowserLayout,
        getBrowserLayoutType: getBrowserLayoutType,
        getBrowserResolution: getBrowserResolution,
        getLayoutType: getLayoutType,
        getLayoutIdFromUri: getLayoutIdFromUri,
        getLayoutTypeFromUri: getLayoutTypeFromUri,
        getDefaultLayoutType: getDefaultLayoutType,
        isDefaultLayout: isDefaultLayout,
        getCurrentLayout: getCurrentLayout,
        getCurrentLayoutType: getCurrentLayoutType,
        copyDropLayout: copyDropLayout,
        applyLayoutRecursive: applyLayoutRecursive
    };
});

